/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Expected_Updated_At_InvalidInputs */

const es_co2_error_expected_updated_at_invalid = /** @type {(inputs: Error_Expected_Updated_At_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos verificar la versión del registro. Recarga la página e intenta de nuevo.`)
};

/**

* @param {Error_Expected_Updated_At_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_expected_updated_at_invalid = /** @type {((inputs?: Error_Expected_Updated_At_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Expected_Updated_At_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_expected_updated_at_invalid(inputs)
});